import type { SvgIconTypes } from '@uikit/svg-icon';

export enum Size {
    small = 'small',
}

export enum Type {
    text = 'text',
    password = 'password',
}

export enum State {
    success = 'success',
    error = 'error',
}

export type Attrs = Record<string, string>;
export type IconData = SvgIconTypes.IconData;
